
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface SidebarHeaderProps {
  isCollapsed: boolean;
  isMobileMenuOpen: boolean;
  onToggleCollapse: () => void;
}

export function SidebarHeader({ isCollapsed, isMobileMenuOpen, onToggleCollapse }: SidebarHeaderProps) {
  return (
    <div className={`p-4 flex ${isMobileMenuOpen ? 'justify-between' : isCollapsed ? 'justify-center' : 'justify-between'} items-center`}>
      {(!isCollapsed || isMobileMenuOpen) && (
        <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">
          Cartas pro Futuro
        </h1>
      )}
      <button
        onClick={onToggleCollapse}
        className="p-1 rounded-lg hover:bg-gray-100 md:block hidden"
      >
        {isCollapsed ? (
          <ChevronRight className="h-5 w-5 text-gray-600" />
        ) : (
          <ChevronLeft className="h-5 w-5 text-gray-600" />
        )}
      </button>
    </div>
  );
}
